<template>
  <div class="fixed z-50 bg-back-2 w-screen h-screen top-0 left-0 flex items-center justify-center">
    <svg width="75" height="69" viewBox="0 0 75 69" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="logo-mask"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="75"
        height="69">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.6713 0C22.2368 0 21.8518 0.279773 21.7175 0.692998L8.94788 39.9924C8.73732 40.6404 9.22035 41.3053 9.90172 41.3053H25.3081L25.3082 41.3052L25.3083 41.3051H47.9754C48.4072 41.3051 48.7905 41.0288 48.9269 40.6191L52.8805 28.7507C53.0968 28.1013 52.6135 27.4308 51.929 27.4308H31.4477C30.7601 27.4308 30.2764 26.7545 30.4986 26.1038L34.4424 14.5532C34.581 14.1472 34.9625 13.8743 35.3915 13.8743H70.1474C70.582 13.8743 70.9672 13.5944 71.1014 13.1809L74.9518 1.31243C75.162 0.664502 74.679 0 73.9978 0H39.4115H23.6572H22.6713ZM4.86185 54.8103C4.4274 54.8103 4.04236 55.09 3.90805 55.5031L0.0498725 67.3716C-0.16079 68.0197 0.322252 68.6846 1.00367 68.6846H52.3275C52.7615 68.6846 53.1463 68.4054 53.2809 67.9928L57.154 56.1243C57.3656 55.4761 56.8825 54.8103 56.2006 54.8103H4.86185Z"
          fill="#232323" />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.6713 0C22.2368 0 21.8518 0.279773 21.7175 0.692998L8.94788 39.9924C8.73732 40.6404 9.22035 41.3053 9.90172 41.3053H25.3081L25.3082 41.3052L25.3083 41.3051H47.9754C48.4072 41.3051 48.7905 41.0288 48.9269 40.6191L52.8805 28.7507C53.0968 28.1013 52.6135 27.4308 51.929 27.4308H31.4477C30.7601 27.4308 30.2764 26.7545 30.4986 26.1038L34.4424 14.5532C34.581 14.1472 34.9625 13.8743 35.3915 13.8743H70.1474C70.582 13.8743 70.9672 13.5944 71.1014 13.1809L74.9518 1.31243C75.162 0.664502 74.679 0 73.9978 0H39.4115H23.6572H22.6713ZM4.86185 54.8103C4.4274 54.8103 4.04236 55.09 3.90805 55.5031L0.0498725 67.3716C-0.16079 68.0197 0.322252 68.6846 1.00367 68.6846H52.3275C52.7615 68.6846 53.1463 68.4054 53.2809 67.9928L57.154 56.1243C57.3656 55.4761 56.8825 54.8103 56.2006 54.8103H4.86185Z"
        fill="#232323" />
      <g mask="url(#logo-mask)">
        <g filter="url(#logo-filter)" id="filter-animate">
          <rect
            x="22.9746"
            y="-41.522"
            width="18"
            height="131"
            transform="rotate(18.2583 22.9746 -41.522)"
            fill="#373737" />
        </g>
      </g>
      <defs>
        <filter
          id="logo-filter"
          x="-42.0674"
          y="-65.522"
          width="106.136"
          height="178.044"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_1_7749" />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<style>
#filter-animate {
  animation: mask 1000ms ease infinite;
  transform: translateX(-60px);
}

@keyframes mask {
  from {
    transform: translateX(-80px);
  }

  to {
    transform: translateX(80px);
  }
}
</style>
